import { createReducer, on } from '@ngrx/store';
import { initialState} from './../state/home.state';
import * as HomeActions from './../actions/home.actions';

export const homeReducer = createReducer(
  initialState,
  on(HomeActions.loadCalendarEvents, (state) => ({ ...state, loading: true })),
  on(HomeActions.loadCalendarEventsSuccess, (state, { calendarEvents }) => ({
    ...state,
    loading: false,
    calendarEvents,
  })),
  on(HomeActions.loadCalendarEventsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(HomeActions.loadEmployeeHours, (state) => ({ ...state, loading: true })),
  on(HomeActions.loadEmployeeHoursSuccess, (state, { employeeHours }) => ({
    ...state,
    loading: false,
    employeeHours,
  })),
  on(HomeActions.loadEmployeeHoursFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(HomeActions.loadEmployeeStatus, (state) => ({ ...state, loading: true })),
  on(HomeActions.loadEmployeeStatusSuccess, (state, { clockStatus }) => ({
    ...state,
    loading: false,
    employeeStatus: clockStatus,
  })),
  on(HomeActions.loadEmployeeStatusFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
